import { booleanAttribute, Component, Input } from '@angular/core';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { Organisation } from 'app/shared/models/organisation.model';

@Component({
  selector: 'ez-contact',
  imports: [ButtonComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  @Input({ required: true }) organisation: Organisation;
  @Input() teaser = '';
  @Input() teaserShort = '';
  @Input() phonePrefix = '';
  @Input() subtitle = '';
  @Input({ transform: booleanAttribute }) withContactForm = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openContactForm() {}
}
